import {PureComponent} from 'react';
import {Router, Switch, Route} from 'react-router-dom';

import {ROUTE_PATH} from 'constants/routes';
import {history} from 'context/history';
import {ClientConference, ClientJoinSessionPage} from 'pages';
import {InviteeToken} from 'services';
import {InviteeParticipantRole} from 'types';

export const CLIENT_CONNECT_TOKEN_QUERY = 'cct';

export default class GuestApp extends PureComponent {

    componentDidMount() {
        InviteeToken.init(InviteeParticipantRole.Guest);
    }

    render() {
        return (
            <Router history={history}>
                <Switch>
                    <Route path={ROUTE_PATH.GUEST.CONFERENCE._SELF} component={ClientConference} />
                    <Route
                        exact
                        path={ROUTE_PATH.GUEST.JOIN}
                        render={(props: any) => <ClientJoinSessionPage {...props} role={InviteeParticipantRole.Guest} />}
                    />
                    <Route
                        exact
                        path={ROUTE_PATH.GUEST.JOIN_WITH_CODE}
                        render={(props: any) => <ClientJoinSessionPage {...props} role={InviteeParticipantRole.Guest} />}
                    />
                </Switch>
            </Router>
        );
    }
}
